// NPM
import React from 'react';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material';

// Components
import InvoiceItemFormattedMessages from '../../../messages/billing/InvoiceItemFormattedMessages';

const InvoiceTable = ({ list, isGodAdmin, sx }) => {
  return (
    <TableContainer sx={{ ...sx }}>
      <Table>
        <TableHead>
          <TableRow>
            {isGodAdmin && (
              <TableCell>{InvoiceItemFormattedMessages.provider}</TableCell>
            )}
            <TableCell>{InvoiceItemFormattedMessages.invoiceNo}</TableCell>
            {isGodAdmin && (
              <TableCell>{InvoiceItemFormattedMessages.customer}</TableCell>
            )}
            <TableCell>{InvoiceItemFormattedMessages.invoiced}</TableCell>
            <TableCell>{InvoiceItemFormattedMessages.paid}</TableCell>
            <TableCell>{InvoiceItemFormattedMessages.status}</TableCell>
            <TableCell>{InvoiceItemFormattedMessages.amount}</TableCell>
            <TableCell>{InvoiceItemFormattedMessages.currency}</TableCell>
            {isGodAdmin && <TableCell>Type</TableCell>}
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{list}</TableBody>
      </Table>
    </TableContainer>
  );
};

export default InvoiceTable;
